// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"799":"482c7d14","927":"0d8ed63e"}[chunkId] + ".chunk.css";
};